export default __webpack_public_path__ + "static/media/loader.18a0b32d.gif";